import { useState, useEffect } from 'react';
import i18n, { type Language } from '../lib/i18n';

export function useTranslation() {
  const [language, setLanguage] = useState<Language>(i18n.language);

  useEffect(() => {
    const unsubscribe = i18n.onLanguageChanged((newLanguage) => {
      setLanguage(newLanguage);
    });

    return unsubscribe;
  }, []);

  return {
    t: i18n.t.bind(i18n),
    i18n,
    language
  };
}

export function useLanguage() {
  const [language, setLanguage] = useState<Language>(i18n.language);

  useEffect(() => {
    const unsubscribe = i18n.onLanguageChanged((newLanguage) => {
      setLanguage(newLanguage);
    });

    return unsubscribe;
  }, []);

  const changeLanguage = (lng: Language) => {
    i18n.changeLanguage(lng);
  };

  return {
    language,
    changeLanguage
  };
}
